import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    TestDetails: {},
}

const TestSlice = createSlice({
    name: "TestSlice",
    initialState,

    reducers: {
        TestData(state, action) {
            return {
                TestDetails: action.payload.TestDetails,
            };
        }
    }
})
export const { TestData } = TestSlice.actions;
export default TestSlice.reducer;